export default __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-7-f1404d1ee8f27e5e89ae8434c71c8b2b.png";